import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import "./twb.css";

const Twb = (props) => {
  const { className } = props;

  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  const closeBtn = (
    <button className='close' onClick={toggle}>
      &times;
    </button>
  );

  return (
    <div>
      <button className='button' onClick={toggle}>
        See the project
      </button>
      <Modal isOpen={modal} toggle={toggle} className={className}>
        <ModalHeader toggle={toggle} close={closeBtn}>
          Modal title
        </ModalHeader>
        <ModalBody className='modalBody'>
          <img
            src='https://res.cloudinary.com/elijjaaahhhh/image/upload/v1614079373/FireShot_Capture_151_-_Multi_Device_Website_Mockup_Generator_-_techsini.com_aa5lab.png'
            alt='img'
          />
          <h2>Travel With Benefits</h2>
          <div className='tag-body-single'>
            <div className='tags'>React</div>
            <div className='tags'>Ruby on Rails</div>
            <div className='tags'>PostgresQl</div>
          </div>
          <p>
            This is a full Stack web application built with Ruby on Rails for
            backend, React for frontend and PostgreSQL for database. This web app makes
            it easy for anyone to book their bus tickets from anywhere in the
            country at their convenience.
          </p>
          <div className='tag-body-live'>
            <div className='tag one'>
              <a href='https://serene-jepsen-7b0096.netlify.app/' target='_blank'>
                See live
              </a>
            </div>
            <div className='tag two'>
              <a href='#work' target='_blank'>
                Locked
              </a>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default Twb;
